import type { FC } from 'react';

import styled, { css } from 'styled-components';

import { media } from '~/components/shared/core/styles';
import { Typography } from '~/components/shared/core/typography/Typography';
import { useTileBaseContext } from '~/components/shared/recommendations/tile/TileBaseContext';
import { useTileContext } from '~/components/shared/recommendations/tile/TileContext';
import { replacePlaceholder } from '~/utilities/helpers/replacePlaceholder';

const Text = styled(Typography)`
  ${({ theme }) => css`
    padding-top: ${theme.padding['4xs']};
    color: ${theme.colors.content.secondary};
    font-size: ${theme.font.size['2']};
    line-height: 1.4;
    min-height: 17px;

    @media ${({ theme }) => media(theme).lessThan('lg')} {
      display: none;
      min-height: auto;
    }
  `}
`;

export const ProductDataAvailableColors: FC = () => {
  const { filteredVariants } = useTileBaseContext();
  const { availableColorsLabel } = useTileContext();

  const isDisplayed = availableColorsLabel && filteredVariants.length > 1;

  return isDisplayed ? (
    <Text data-testid="product-tile-available-colors">
      {!!filteredVariants?.length &&
        replacePlaceholder(availableColorsLabel, {
          counter: filteredVariants?.length,
        })}
    </Text>
  ) : (
    <></>
  );
};
